import { useEffect, useState, useRef, Fragment } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { get, put, post } from "util/requests";
import styles from "../crf_builder.module.css";
import crf_styles from "../../edc/components/crf/crf.module.css";
import { Select, Checkbox } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { cloneDeep } from "lodash";
import DomainSelectModal from "ui/modals/domain_select";
import RegionSelectModal from "ui/modals/region_select";
import Logic from "./logic";
import EditableText from "./editable_text";
import EntryRules from "./entry_rules";
import AddIcon from "@mui/icons-material/Add";
import Data from "./data";
import Config from "./config";
import Selections from "./options";

export default function FieldRow(props) {
  const {
    field,
    options,
    changeType,
    changeLabel,
    changeVariableName,
    addAbove,
    addBelow,
    removeField,
    updateField,
    setOptions,
    setReadOnly,
    setRequired,
    setDomainModalIsOpenData,
    setRegionModalisOpenData,
    regions,
    tabOverride,
    setTabOverride,
    fieldArray,
  } = props;

  useEffect(() => {
    if (tabOverride) {
      setActiveTab(tabOverride);
    }
  }, [tabOverride]);
  const [activeTab, setActiveTab] = useState("data");

  const handleTabClick = (key) => {
    if (key !== tabOverride) {
      setTabOverride(null);
    }
    setActiveTab(key);
  };

  const getClassName = (key) => {
    if (key === activeTab) {
      return styles.tile_button_active;
    } else {
      return styles.tile_button;
    }
  };

  const setFieldValue = (key, value) => {
    let _field = cloneDeep(field);
    _field[key] = value;
    updateField(_field.id, _field);
  };

  return (
    <div className={styles.entry_row} key={field.key}>
      <div className={styles.row_select}>
        <div className={styles.type_select}>
          <div className={styles.field_id}>{field.id}</div>
          <Select
            value={field.type || ""}
            sx={{
              fontSize: 14,
              minWidth: 200,
              height: 30,
              padding: 0,
              alignSelf: "center",
            }}
            onChange={(e) => changeType(field.id, e.target.value)}
          >
            {options &&
              options.length &&
              options.map((o) => (
                <MenuItem key={o.value} value={o.value}>
                  {o.label}
                </MenuItem>
              ))}
          </Select>
        </div>

        <div className={styles.order_buttons}>
          <div className={styles.add_button} onClick={() => addAbove(field.id)}>
            <AddIcon sx={{ fontSize: "14px", margin: 0 }} />
            above
          </div>
          <div className={styles.add_button} onClick={() => addBelow(field.id)}>
            <AddIcon sx={{ fontSize: "14px", margin: 0 }} />
            below
          </div>
          <div className={styles.add_button} onClick={() => removeField(field.id)}>
            remove
          </div>
        </div>
      </div>
      <div>
        <div className={styles.row_name}>
          <div>
            <span className={styles.heading}>Question Text</span>
          </div>
          {field.versioning_field ? (
            <Select
              value={field.active_version_string || ""}
              sx={{
                fontSize: 14,
                minWidth: 200,
                height: 30,
                padding: 0,
                alignSelf: "center",
              }}
              onChange={(e) => setFieldValue("active_version_string", e.target.value)}
            >
              {fieldArray
                .find((f) => parseInt(f.id) === parseInt(field.versioning_field_id))
                ?.options?.map((f) => (
                  <MenuItem key={f.value} value={f.value}>
                    {f.label}
                  </MenuItem>
                ))}
            </Select>
          ) : null}
          <EditableText
            text={field.versioning_field ? field.label[field.active_version_string] || "placeholder" : field.label}
            onChange={(value) => {
              let _label;
              if (field.active_version_string) {
                if (field.label?.constructor === Object) {
                  _label = { ...field.label };
                  _label[field.active_version_string] = value;
                } else {
                  _label = { [field.active_version_string]: value };
                }
                changeLabel(field.id, _label);
              } else {
                changeLabel(field.id, value);
              }
            }}
            placeholder={"placeholder"}
          />
        </div>
      </div>
      <div>
        <div className={getClassName("data")} onClick={() => handleTabClick("data")}>
          Data
        </div>
        <div className={getClassName("options")} onClick={() => handleTabClick("options")}>
          Options
        </div>
        <div className={getClassName("config")} onClick={() => handleTabClick("config")}>
          Config
        </div>
        <div className={getClassName("logic")} onClick={() => handleTabClick("logic")}>
          Logic
        </div>
        <div className={getClassName("rules")} onClick={() => handleTabClick("rules")}>
          Rules
        </div>
      </div>
      <div className={styles.tab_section_wrapper}>
        {activeTab === "data" && <Data field={field} changeVariableName={changeVariableName} />}
        {activeTab === "config" && field.type !== "add_another" ? (
          <Config
            field={field}
            updateField={updateField}
            setMainCrfOptions={setOptions}
            setReadOnly={setReadOnly}
            setRequired={setRequired}
          />
        ) : null}
        {activeTab === "logic" && (
          <Logic
            field={field}
            updateField={updateField}
            setDomainModalIsOpenData={setDomainModalIsOpenData}
            setRegionModalisOpenData={setRegionModalisOpenData}
            regions={regions}
          />
        )}
        {activeTab === "rules" &&
        [
          "year",
          "int",
          "weight",
          "decimal",
          "datetime",
          "date",
          "blood_pressure_date_time",
          "blood_pressure",
          "blood_test_result",
        ].includes(field.type) ? (
          <EntryRules field={field} updateField={updateField} />
        ) : null}
      </div>
      {activeTab === "options" &&
      ["blood_test_result", "text", "decimal", "int", "radio", "select", "drop_down"].includes(field.type) ? (
        <Selections
          field={field}
          updateField={updateField}
          setMainCrfOptions={setOptions}
          fieldArray={fieldArray}
          setRegionModalisOpenData={setRegionModalisOpenData}
          regions={regions}
        />
      ) : null}

      {false &&
      [
        "year",
        "int",
        "weight",
        "decimal",
        "datetime",
        "date",
        "blood_pressure_date_time",
        "blood_pressure",
        "blood_test_result",
      ].includes(field.type) ? (
        <div className={styles.data_column}>
          <EntryRules field={field} updateField={updateField} />
        </div>
      ) : null}
    </div>
  );
}
